
import React from "react";
import "./SameDayCleaningService.css";

const SameDayCleaningService = () => {
  return (
    <div className="samedaycleaning-cleaning-container">
      <h1>Need a Clean Home Today? We've Got You Covered</h1>
      <p>Our Same Day Cleaning service is designed for urgent situations where fast, efficient, and professional cleaning is essential — perfect for last-minute guests or surprise events.</p>
      <h2>What’s Included:</h2>
      <ul>
        <li>Quick clean of living areas, kitchen, and bathroom</li>
<li>Surface wipe-down and sanitization</li>
<li>Vacuuming and mopping floors</li>
<li>Trash removal</li>
<li>Tidy-up and final inspection</li>

      </ul>
    </div>
  );
};

export default SameDayCleaningService;
